import './App.css';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/800.css';
import '@fontsource/montserrat/900.css';
import {Grid} from "@mui/material";
import Pagina from "./Pagina/Pagina";
import {createContext, useEffect} from "react";
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {where} from "firebase/firestore";

export const contexApp = createContext()

function App() {
    const {data: anuncios, actualizarDataLocal: actAnuncios} = useObtenerDataActualizada({
        clave: 'anuncios',
    })
    const {data: tipos, actualizarDataLocal: actTipos} = useObtenerDataActualizada({
        clave: 'categoriasTipo',
    })
    const {data: reservas, actualizarDataLocal: actReservas} = useObtenerDataActualizada({
        clave: 'categoriasReserva',
    })
    const {data: madureces, actualizarDataLocal: actMadureces} = useObtenerDataActualizada({
        clave: 'categoriasMadurez',
    })
    const {data: origenes, actualizarDataLocal: actOrigenes} = useObtenerDataActualizada({
        clave: 'categoriasOrigen',
    })
    const {data: marcas, actualizarDataLocal: actMarcas} = useObtenerDataActualizada({
        clave: 'marcas',
    })
    const {data: politicas, actualizarDataLocal: actPoliticas} = useObtenerDataActualizada({
        clave: 'politicas',
    })
    const {data: rutas, actualizarDataLocal: actRutas} = useObtenerDataActualizada({
        clave: 'rutas',
    })



    const valoresProvider = {
        anuncios,
        tipos,
        reservas,
        madureces,
        origenes,
        marcas,
        politicas,
        rutas

    }

    const {Provider} = contexApp;

    useEffect(() => {

        //se verifica si esta o no actualizado

        let w = [where('estado', '==', 'Publicado')]
        obtenerFechaAct('anuncios').then((dox) => {
            actAnuncios({fecha: dox, wheres: w}).then()
        })

        obtenerFechaAct('categoriasTipo').then((dox) => {
            actTipos({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('categoriasReserva').then((dox) => {
            actReservas({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('categoriasMadurez').then((dox) => {
            actMadureces({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('categoriasOrigen').then((dox) => {
            actOrigenes({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('marcas').then((dox) => {
            actMarcas({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('politicas').then((dox) => {
            actPoliticas({fecha: dox, wheres: []}).then()
        })

        obtenerFechaAct('rutas').then((dox) => {
            actRutas({fecha: dox, wheres: []}).then()
        })


    }, []);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>

        </Grid>
    );
}

export default App;
